import React from 'react';

import PageHeader from '../components/header/page';

import './impressum.scss'

const ImpressumPage = props =>
  (<main>
    <PageHeader headline="Impressum" />
    <div id="impressum" className="container-custom">
    	<section>
    		<p>Für den Inhalt verantwortlich gemäß <strong>§ 10 Absatz 3 MDStV</strong>:<br/></p>
    	</section>
    	<section>
    		<ul>
	    		<li><strong>Magnet Resonanz Institut Bregenz GmbH</strong></li>
	    		<li>Dr. Herbert Vonbank, Dr. Matthias Dietlein, Dr. Peter Mittelberger</li><li>UID Nr.: ATU57326003</li>
	    		<li>Firmenbuchnummer: FN237376</li><li>Zuständiges Gericht: Landesgericht Feldkirch als Firmenbuchgericht, Schillerstraße 1, 6800</li>
    		</ul>
    	</section>
    	<section>
    		<address>Römerstraße 9-13 <br/>6900 Bregenz <br/>Telefon: <a href="tel: 0043557453500">+43 5574 53500</a><br/>E-Mail: <a href="mailto:office@radbregenz.at">office@radbregenz.at</a><br/><a href="www.radbregenz.at">www.radbregenz.at</a></address>
    	</section>
    	<section>
    		<ul>
	    		<li>Mitglied der Wirtschaftskammer Vorarlberg</li>
	    		<li><a href="https://firmen.wko.at/Web/DetailsKontakt.aspx?FirmaID=80c8a525-89ac-4211-adc7-a8e25d9d2d94&amp;StandortID=132">Gewerbeordnung</a></li>
	    		<li>Bezirkshauptmannschaft: BH Bregenz</li>
    		</ul>
    	</section>
    	<section>
    		<a target="_blank" href="/Anstaltsordnung.pdf">Anstaltsordnung</a>
    	</section>
			<section>
    		<p>Design &amp; Programmierung: <a href="https://zeughaus.com">Zeughaus Design GmbH</a>, Neustadt 11, 6800 Feldkirch</p>
    	</section>
    	<section>
    		<p>Haftungshinweis: Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.</p>
		</section>
    </div>
  </main>);

export default ImpressumPage;


// WEBPACK FOOTER //
// ./src/pages/impressum.js